module.exports = __webpack_public_path__ + "img/1.7e2934c9.png";